// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item--dense[data-v-5ca503b0], .v-list--dense .v-list-item[data-v-5ca503b0] {\n  min-height: 30px !important;\n}\np[data-v-5ca503b0] {\n  display: inline-block;\n}", ""]);
// Exports
module.exports = exports;
